import(/* webpackMode: "eager" */ "/tmp/seed/source/apps/web/app/(normal)/error.tsx");
